<template lang="pug">
  .cookie-agreement
    .cookie-content
      p This website uses cookies to ensure you get the best experience on our website.
        a(href="https://www.cookiesandyou.com/", target="_blank") Learn more
      button.button(v-on:click="consentToCookies") Agree
</template>

<script>
export default {
  name: 'CookieConsent',
  methods: {
    consentToCookies () {
      this.$cookies.set("ppr_cookiesConsented", true, "24d")
      let cookiesConsented = this.$cookies.get("ppr_cookiesConsented")
      if (cookiesConsented === 'true') {
        document.querySelector('.cookie-agreement').setAttribute('class', 'cookie-agreement hidden')
      }
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/helpers/mixins.styl'

.cookie-agreement
  background-color $brown
  bottom 0
  left 0
  position fixed
  width 100%
  z-index 90000
  &.hidden
    display none
  .cookie-content
    padding 1rem 10% 1rem 10%
    align-items center
    display flex
    justify-content space-between
    p
      background-color $brown
      color $white
    a
      color $white
      margin-left 0.25rem
      text-decoration underline
    button
      background-color $brown-shade
      border-radius 5px
      border-style none
      color $white
      font-family $font-primary
      font-size 16px
      margin-left 1rem
      padding 0.75rem 1rem
      transition ease-in-out 0.2s
      transition-timing-function cubic-bezier(.17,.67,.83,.67)
      &:hover
        background-color darken($brown-shade, 10%)
        color $white
        cursor pointer

@media (max-width: 642px)
  .cookie-agreement
    .cookie-content
      padding 0.5rem 2rem 0.5rem 2rem
      flex-direction column
      button
        margin-left 0
        margin-top 0
        width 100%
</style>
